import React, { useState, useEffect, useRef } from 'react';
import {
    Box,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TablePagination,
    TableRow,
    TableSortLabel,
    makeStyles,
} from '@material-ui/core';
import ArrowDropUpIcon from '@material-ui/icons/ArrowDropUp';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import { useStoreContext } from "../../store/Store";
import { BrandPopover } from "./BrandPopover";
import { BrandCheckbox } from "./BrandCheckbox";

const useStyles = makeStyles((theme) => ({
    tableRow: {
        '&:hover': {
            backgroundColor: theme.overrides.MuiTable.tableRow.background,
            cursor: "pointer",
        }
    },
    tableRowCell: {
        borderColor: theme.overrides.MuiTable.tableRowCell.background,
        // paddingRight: theme.spacing(5),
        display: 'flex',
        minWidth: 0,
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        display: 'flex',
        minWidth: 0,
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
    },
    activeHeadCell: {
        color: `${theme.overrides.MuiTable.activeHeadCell.color} !important`,
        '& .MuiSvgIcon-root': {
            color: 'white !important'
        }
    },
    inactiveHeadCell: {
        color: 'white',
        '& .MuiTableSortLabel-icon': {
            color: 'white !important'
        }
    },
    tableHead: {
        backgroundColor: theme.palette.background.light,
        marginBottom: theme.spacing(1),
        '& .MuiTableSortLabel-root': {
            font: 'normal normal normal 16px/18px Roboto !important',
            letterSpacing: '0.6px !important',
        },
        '& .MuiTableCell-root': {
            font: 'normal normal normal 16px/18px Roboto !important',
            letterSpacing: '0.6px !important',
            borderBottom: 'none',
        },
        '& span': {
            font: 'normal normal normal 16px/18px Roboto !important',
            letterSpacing: '0.6px !important',
        },
        '& .MuiAutocomplete-root': {
            marginLeft: 15,
            marginTop: 6,
        }
    },
    tableContainer: {
        '& .MuiPaper-rounded': {
            borderRadius: 0,
            boxShadow: 'none',
            border: 'none',
        },
        '& .MuiTableBody-root': {
            '& .MuiTableCell-root': {
                font: 'normal normal normal 16px / 18px Roboto !important',
                letterSpacing: '0px !important',
                borderBottom: 'none',
            },
            display: 'flex',
            flexDirection: 'column',
            height: '100%'
        },
        '& .Mui-selected': {
            backgroundColor: 'transparent',
            '&:hover': {
                backgroundColor: 'transparent',
            },
        },
        width: '100%',
        marginBottom: theme.spacing(2),
    },
    toggleRow: {
        display: 'flex',
        flexDirection: 'column'
    },
    checkboxColumn: {
        '& .MuiTableCell-root': {
            padding: '0px',
            borderBottom: 'none',
        }
    },
    autocompleteContainer: {
        display: 'flex',
        justifyContent: 'start',
        alignItems: 'center',
        gap: 10,
        "& .MuiSvgIcon-root:hover": {
            cursor: "pointer",
            color: theme.palette.primary.main
        }
    },
    autocomplete: {
        "& .MuiAutocomplete-clearIndicatorDirty": {
            display: 'none'
        },
        "& .MuiAutocomplete-popupIndicator": {
            display: 'none'
        },
    },
    tableHeadContainer: {
        backgroundColor: theme.palette.background.light,
        borderRadius: '6px',
        border: `1px solid ${theme.palette.primary.borderStroke}`,
        marginBottom: theme.spacing(2),
        width: '100%',
        maxWidth: '100vw',
    },
    truncatedText: {
        display: 'block',
        width: '100%',
        maxWidth: '100%',
        minWidth: 0,
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis'
    },
    naContainer: {
        color: theme.palette.primary.alert,
    },
    headerContainer: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        border: `1px solid ${theme.palette.primary.borderStroke}`,
        borderRadius: '6px',
        backgroundColor: theme.palette.background.light,
        marginBottom: theme.spacing(1),
        minHeight: theme.spacing(7),
        '& .MuiTableCell-root': {
            borderBottom: 'none',
            padding: '0px'
        }
    },
    headerColumn: {
        height: '100%',
        justifyContent: 'space-between',
        padding: `${theme.spacing(1)}px ${theme.spacing(1)}px ${theme.spacing(1)}px ${theme.spacing(1)}px`,
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        whiteSpace: 'wrap',
        '& .MuiTableSortLabel-root': {
            font: 'normal normal normal 16px Roboto !important',
            letterSpacing: '0.6px !important',
        }
    },
    bodyContainer: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        border: `1px solid ${theme.palette.primary.borderStroke}`,
        borderRadius: '6px',
        marginBottom: theme.spacing(1),
        minHeight: theme.spacing(7),
        '& .MuiTableCell-root': {
            padding: `${theme.spacing(1)}px ${theme.spacing(1)}px ${theme.spacing(1)}px ${theme.spacing(1)}px`
        },
        '&:hover': {
            borderColor: theme.palette.primary.main
        }
    },
    bodyColumn: {
        padding: theme.spacing(1),
        width: '100%',
        height: '100%',
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        whiteSpace: 'wrap',
        '& .MuiTableCell-root': {
            font: 'normal normal normal 16px / 18px Roboto !important',
            letterSpacing: '0px !important',
            borderBottom: 'none',
            padding: '0px'
        }
    },
}));



function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
        return -1;
    }
    if (b[orderBy] > a[orderBy]) {
        return 1;
    }
    return 0;
}

function getComparator(order, orderBy) {
    return order === 'desc'
        ? (a, b) => descendingComparator(a, b, orderBy)
        : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const order = comparator(a[0], b[0]);
        if (order !== 0) {
            return order;
        }
        return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
}

function EnhancedTableHead({ headCells, onSelectAllClick, order, orderBy, numSelected, rowCount, onRequestSort, checkboxless = true, stylesHeader, stickyHeader, rows }) {
    const styles = useStyles();
    // const [inputVisibility, setInputVisibility] = useState(false)

    const createSortHandler = (property) => (event) => {
        onRequestSort(event, property);
    };

    return (
        <TableHead className={styles.headerContainer}>
            {!checkboxless && (
                <TableRow
                    className={styles.headerColumn}
                >
                    <TableCell className={styles.checkboxColumn}>
                        <BrandCheckbox
                            checked={numSelected === rowCount}
                            onChange={onSelectAllClick}
                        />
                    </TableCell>
                </TableRow>
            )}
            {headCells.map((headCell, index) => {
                const multiselectEnabled = index === 0 && !checkboxless;
                // const isLast = index === headCells.length - 1;
                return (
                    <TableRow
                        key={headCell.id || index}
                        className={styles.headerColumn}
                        style={{
                            width: headCell?.width || '100%',
                            minWidth: headCell?.minWidth || '200px',
                            maxWidth: headCell?.maxWidth || '100vw',
                        }}
                    >
                        {multiselectEnabled ? (
                            <>
                                {headCell.hideHeadLabel ? '' :
                                    headCell.notSortable ? headCell.label :
                                        <TableCell>
                                            <TableSortLabel
                                                active={true}
                                                className={orderBy === headCell.id ? styles.activeHeadCell : styles.inactiveHeadCell}
                                                direction={orderBy === headCell.id ? order : 'desc'}
                                                onClick={createSortHandler(headCell.id)}
                                                IconComponent={orderBy === headCell.id ? ArrowDropUpIcon : ArrowDropDownIcon}
                                            >
                                                {headCell.label}
                                            </TableSortLabel>
                                        </TableCell>
                                }
                            </>
                        ) : (
                            <TableCell>
                                {headCell.hideHeadLabel ? '' :
                                    headCell.notSortable ? headCell.label :
                                        <TableSortLabel
                                            active={true}
                                            className={orderBy === headCell.id ? styles.activeHeadCell : styles.inactiveHeadCell}
                                            direction={orderBy === headCell.id ? order : 'desc'}
                                            onClick={createSortHandler(headCell.id)}
                                            IconComponent={orderBy === headCell.id ? ArrowDropUpIcon : ArrowDropDownIcon}
                                        >
                                            {headCell.label}
                                        </TableSortLabel>
                                }
                            </TableCell>
                        )}
                    </TableRow>
                );
            })}
        </TableHead>
    );
}

export default function BrandTable({
    rows,
    headCells,
    checkboxless = true,
    page,
    setPage,
    hidePagination,
    setSortBy,
    setSortType,
    rowIsClickable,
    additionalData,
    onRowClick,
    ToggleRowData,
    setSelectedRows,
    setSelectedIds,
    selectedIds,
    rowsPerPageOptions,
    rowsPerPage,
    setRowsPerPage,
    tableSize,
    stylesHeader,
    maxHeight,
    containerRef,
    stickyHeader
}) {
    const [order, setOrder] = useState('asc');
    const [orderBy, setOrderBy] = useState('');
    const [selected, setSelected] = useState(selectedIds || []);
    const [selectedData, setSelectedData] = useState({});
    const styles = useStyles();
    const [state, setState] = useStoreContext();
    const tableRowRef = useRef();

    const handleRequestSort = (event, property) => {
        const isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
        if (hidePagination) {
            setSortBy(property)
            setSortType(isAsc ? 'DESC' : 'ASC')
        }
    };

    const handleSelectAllClick = (event) => {
        if (event.target.checked) {

            const tempSelectedData = {};
            const newSelecteds = rows
                .filter(n => !n.disabled)
                .map((n) => {
                    tempSelectedData[n.id] = n;
                    return n.id;
                });
            setSelected(newSelecteds);
            setSelectedData({ ...tempSelectedData });
            return;
        }
        setSelected([]);
        setSelectedData({});
    };

    const handleClick = (event, id, row) => {
        const selectedIndex = selected.indexOf(id);
        let newSelected = [];
        const tempSelectedData = selectedData;

        if (event.target.checked) {
            tempSelectedData[id] = row;
        } else {
            delete tempSelectedData[id];
        }

        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, id);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selected.slice(0, selectedIndex),
                selected.slice(selectedIndex + 1),
            );
        }

        setSelected(newSelected);
        setSelectedData({ ...tempSelectedData });
    };

    useEffect(() => {
        if (setSelectedRows) {
            setSelectedRows({ ...selectedData })
        }
        if (setSelectedIds) {
            setSelectedIds([...selected])
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedData, selected])

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const isSelected = (id) => selected.indexOf(id) !== -1;
    // eslint-disable-next-line no-unused-vars
    const emptyRows = rowsPerPage - Math.min(rowsPerPage, rows.length - page * rowsPerPage);

    useEffect(() => {
        if (rows.length > 0) {
            setState(state => (state.tableRowHeight = tableRowRef.current?.clientHeight, { ...state }));
        }
    }, [rows]);

    return (
        <Box className={styles.tableContainer}>
            <Paper sx={{ width: '100%', mb: 2 }}>
                <TableContainer style={{ maxHeight: maxHeight }} ref={containerRef}>

                    <Table
                        sx={{ tableLayout: 'fixed', minWidth: 750 }}
                        aria-labelledby="tableTitle"
                        size={tableSize ? tableSize : 'medium'}
                    >
                        <EnhancedTableHead
                            rows={rows}
                            headCells={headCells}
                            numSelected={selected.length}
                            order={order}
                            orderBy={orderBy}
                            onSelectAllClick={handleSelectAllClick}
                            onRequestSort={handleRequestSort}
                            rowCount={rows.filter(r => !r.disabled).length}
                            checkboxless={checkboxless}
                            stylesHeader={stylesHeader}
                            stickyHeader={stickyHeader}
                        />
                        <TableBody>
                            {hidePagination ?
                                rows.map((row, index) => {
                                    const isItemSelected = isSelected(row.id);
                                    const labelId = `enhanced-table-checkbox-${index}`;
                                    return (
                                        row && row.toggledRow ?
                                            <ToggleRowData row={row} additionalData={additionalData} />
                                            :
                                            <TableRow
                                                key={`${row.id}-${index}` || index}
                                                className={styles.bodyContainer}
                                                onClick={
                                                    checkboxless ?
                                                        rowIsClickable ?
                                                            (event) => onRowClick(event, row)
                                                            : null
                                                        : rowIsClickable ?
                                                            (event) => handleClick(event, row.id, row)
                                                            : null
                                                }
                                            >
                                                {!checkboxless && (
                                                    <TableCell className={styles.checkboxColumn}>
                                                        <BrandCheckbox
                                                            checked={isItemSelected}
                                                            onChange={(event) => {
                                                                event.stopPropagation();
                                                                handleClick(event, row.id, row);
                                                            }}
                                                            inputProps={{
                                                                'aria-labelledby': labelId,
                                                            }}
                                                        />
                                                    </TableCell>
                                                )}
                                                {headCells.map((headCell, i) => {
                                                    const CellRender = headCell.CellRender;
                                                    return (
                                                        <TableCell
                                                            key={headCell.id ? headCell.id + i : i}
                                                            className={styles.bodyColumn}
                                                            style={{
                                                                width: headCell?.width || '100%',
                                                                minWidth: headCell?.minWidth || '200px',
                                                                maxWidth: headCell?.maxWidth || '100vw',
                                                            }}
                                                        >
                                                            {CellRender ?
                                                                headCell.popover ? (
                                                                    <BrandPopover
                                                                        popoverData={row[headCell.id]}
                                                                        popoverDataFormated={
                                                                            <CellRender
                                                                                key={headCell.id ? headCell.id + i : i}
                                                                                index={i}
                                                                                additionalData={additionalData}
                                                                                cellData={row[headCell.id]}
                                                                                rowData={row}
                                                                                tableRows={rows}
                                                                                className={styles.truncatedText}
                                                                            />
                                                                        }
                                                                    />
                                                                ) : (
                                                                    <CellRender
                                                                        key={headCell.id ? headCell.id + i : i}
                                                                        index={i}
                                                                        additionalData={additionalData}
                                                                        cellData={row[headCell.id]}
                                                                        rowData={row}
                                                                        tableRows={rows}
                                                                    />
                                                                )
                                                                : headCell.popover ? (
                                                                    <BrandPopover
                                                                        popoverData={row[headCell.id]}
                                                                        popoverDataFormated={
                                                                            <div className={styles.truncatedText} style={{ paddingLeft: i === headCells.length - 1 ? 8 : undefined }}>
                                                                                {row[headCell.id] ? row[headCell.id] : <div className={styles.naContainer}>N/A</div>}
                                                                            </div>
                                                                        }
                                                                    />
                                                                ) : (
                                                                    <div className={styles.truncatedText} style={{ paddingLeft: i === headCells.length - 1 ? 8 : undefined }}>
                                                                        {row[headCell.id] ? row[headCell.id] : <div className={styles.naContainer}>N/A</div>}
                                                                    </div>
                                                                )
                                                            }
                                                        </TableCell>
                                                    );
                                                })}
                                            </TableRow>
                                    );
                                })
                                :
                                stableSort(rows, getComparator(order, orderBy))
                                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                    .map((row, index) => {
                                        const isItemSelected = isSelected(row.id);
                                        const labelId = `enhanced-table-checkbox-${index}`;
                                        return (
                                            row && row.toggledRow ?
                                                <ToggleRowData props={row} />
                                                :
                                                <TableRow
                                                    key={row.id || index}
                                                    className={styles.bodyContainer}
                                                    onClick={
                                                        checkboxless ?
                                                            rowIsClickable ?
                                                                (event) => onRowClick(event, row)
                                                                : null
                                                            : (event) => handleClick(event, row.id, row)
                                                    }
                                                >
                                                    {!checkboxless && (
                                                        <TableCell className={styles.checkboxColumn}>
                                                            <BrandCheckbox
                                                                checked={isItemSelected}
                                                                onChange={(event) => {
                                                                    event.stopPropagation();
                                                                    handleClick(event, row.id, row);
                                                                }}
                                                                inputProps={{
                                                                    'aria-labelledby': labelId,
                                                                }}
                                                            />
                                                        </TableCell>
                                                    )}
                                                    {headCells.map((headCell, i) => {
                                                        const CellRender = headCell.CellRender;
                                                        return (
                                                            <TableCell
                                                                key={headCell.id ? headCell.id + i : i}
                                                                className={styles.bodyColumn}
                                                                style={{
                                                                    width: headCell?.width || '100%',
                                                                    minWidth: headCell?.minWidth || '200px',
                                                                    maxWidth: headCell?.maxWidth || '100vw',
                                                                }}
                                                            >
                                                                {CellRender ?
                                                                    <CellRender
                                                                        key={headCell.id ? headCell.id + i : i}
                                                                        cellData={row[headCell.id]}
                                                                        additionalData={additionalData}
                                                                        rowData={row}
                                                                        tableRows={rows}
                                                                    />
                                                                    : row[headCell.id]
                                                                }
                                                            </TableCell>
                                                        );
                                                    })}
                                                </TableRow>
                                        );
                                    })}
                            {emptyRows > 0 && (
                                <TableRow style={{ height: 75 * emptyRows }} />
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>
                {hidePagination ? null :
                    <TablePagination
                        rowsPerPageOptions={rowsPerPageOptions}
                        component="div"
                        count={rows.length}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                    />
                }
            </Paper>
        </Box>
    );
}
